export var colorStyle = 'dark';
export var POST_SHADOW = '0px 4px 4px rgba(0, 0, 0, 0.12);';
export var MAC13_COLORED_FONT_SIZE = 26;
export var FontSizes = {
    common: {
        m: { fs: 17, lh: 22 }
    },
    bigText: {
        // m: { fs: 28.5, lh: 35 }
        m: { fs: 29, lh: 39.5 }
    },
    regularText: {
        m: { fs: 16, lh: 24 }
    },
    captionText: {
        m: { fs: 20, lh: 32 }
    }
};
//# sourceMappingURL=theme.js.mapexport var colorStyle = 'dark';
export var POST_SHADOW = '0px 4px 4px rgba(0, 0, 0, 0.12);';
export var MAC13_COLORED_FONT_SIZE = 26;
export var FontSizes = {
    common: {
        m: { fs: 17, lh: 22 }
    },
    bigText: {
        // m: { fs: 28.5, lh: 35 }
        m: { fs: 29, lh: 39.5 }
    },
    regularText: {
        m: { fs: 16, lh: 24 }
    },
    captionText: {
        m: { fs: 20, lh: 32 }
    }
};
//# sourceMappingURL=theme.js.map